import styled from "styled-components"
import { Link } from "gatsby"
export const Nav = styled.nav`
  width: 100%;
  height: 80px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 1rem;
  position: sticky;
  z-index: 10;
  top: 0;

  @media screen and (max-width: 960px) {
    transition: all 0.8s ease;
  }
`
export const NavBarContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  z-index: 1;
  height: 80px;
  width: 100%;
  padding: 0 24px;
  max-width: 1100px;
  position: relative;
`

export const NavLogo = styled(Link)`
  display: flex;
  color: #404040;
  justify-self: flex-start;
  cursor: pointer;
  font-size: 1.5rem;
  align-items: center;
  margin-left: 24px;
  font-family: prata, sans-serif;
  font-weight: bold;
  text-decoration: none;
`

export const MobileIcon = styled.div`
  display: none;
  @media screen and (max-width: 768px) {
    display: block;
    transform: translate(-100%, 60%);
    font-size: 1.8rem;
    cursor: pointer;
    color: #404040;
    position: absolute;
    top: 6px;

    right: ${props => (props.right ? "75%" : "0")};
  }
`
export const NavMenu = styled.ul`
  display: flex;
  align-items: center;
  list-style: none;
  text-align: center;
  margin: auto 0;

  @media screen and (max-width: 768px) {
    display: none;
  }
`
export const NavItem = styled.li`
  height: 80px;
`

export const NavLink = styled(Link)`
  color: #646369;
  display: flex;
  align-items: center;
  text-decoration: none;
  padding: 0 1rem;
  height: 100%;
  transition: all 0.2ms ease-in-out;
  cursor: pointer;

  &:hover {
    border-bottom: 3px solid #0066ff;
    color: #000;
  }
`
